<template>
    <div class="header">
       <div class="inner-header">
        <img :src="require('@/assets/image/logo.png')" @click.stop="back" alt="" class="logo mouse-style">
        <div class="search">
           <el-input v-model="keyword" class="search-input" prefix-icon="el-icon-search" :placeholder="placeholder">
                <template slot="append"><el-button class="search-btn mouse-style" @click.stop="search">搜索</el-button></template>
          </el-input>
        </div>
       </div>
    </div>
</template>
<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      keyword: ''
    }
  },
  methods: {
    back () {
      if (this.$route.name === 'Home') {
        return
      }
      this.$emit('back')
      this.$router.push({
        name: 'Home'
      })
    },
    search () {
      this.$emit('handleSearch', this.keyword)
    }
  }
}
</script>
<style lang="scss" scoped>
.header{
  padding:18px 0;
  background:#fff;
}
.inner-header{
    width:1200px;
    margin:0 auto;
    display:flex;
    justify-content: space-between;
}
.logo{
    width:155px;
    height:44px;
}
.search{
  display:inline-block;

}
.search-input ::v-deep .el-input__inner{
  width: 231px;
  height: 32px;
  opacity: 1;
  border-radius: 7px;
  border-right:none;
   border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  box-sizing:border-box;
}
.search ::v-deep .el-input__icon{
  line-height:32px;
}
.search-input ::v-deep .el-input-group__append{
  width:76px;
  height:32px;
  background:#187FC3;
  color:#fff;
  border-left:none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding:0;
  text-align:center;
  border:none;
  box-sizing: border-box;
}
@media screen and (max-width: 1200px){
  .inner-header{
    width:100%
  }
}
</style>
